<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->

  <div>
    <div v-if="summary" class="md:grid-cols- grid grid-rows-1 gap-4 md:gap-8">
      <div class="flex items-center gap-4">
        <IconSparkles class="text-[#AFC354]" size="24" />
        <div class="gradient-text title heading-2">
          {{ i18n(translations.title) }}
        </div>
      </div>
      <p class="summary text-static-default-mid body-1 col-span-1 text-justify">
        {{ summary }}
      </p>

      <span
        class="caption-grid-item text-static-default-low flex shrink-0 items-center gap-4 py-6 md:justify-end"
        >{{ i18n(translations.caption) }}
        <RevTooltip>
          <template #trigger="{ show, hide }">
            <IconInfo
              class="inline"
              size="16"
              @focusin="show"
              @focusout="hide"
              @mouseleave="hide"
              @mouseover="show"
            />
          </template>

          {{ i18n(translations.tooltip, { updateDate: formattedUpdatedAt }) }}
        </RevTooltip>
      </span>
    </div>

    <RevSkeleton
      v-else-if="pending"
      height="100px"
      shape="rectangle"
      width="100%"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconSparkles } from '@ds/icons/IconSparkles'

import translations from './AISummary.translations'

const i18n = useI18n()

const props = defineProps<{
  productName: string
  summary: string | undefined
  pending: boolean
  updatedAt: string | undefined
}>()

const formattedUpdatedAt = computed(() => {
  if (!props.updatedAt) return ''

  return i18n.date(new Date(props.updatedAt))
})
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(to right, #afc354, #e7729e);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.summary {
  @media screen and (min-width: theme('screens.md')) {
    grid-column: 1 / span 2;
    grid-row: 2;
  }
}

.caption-grid-item {
  @media screen and (min-width: theme('screens.md')) {
    grid-column: 2;
    grid-row: 1;
  }
}

.title {
  @media screen and (min-width: theme('screens.md')) {
    grid-column: 1;
    grid-row: 1;
  }
}
</style>
